export const formatPrice = (price: number, decimal=2) => {
    const number = price.toFixed(decimal)
    return number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
}
